import { render, staticRenderFns } from "./adminSettings.vue?vue&type=template&id=11c5e75c"
import script from "./adminSettings.vue?vue&type=script&lang=js"
export * from "./adminSettings.vue?vue&type=script&lang=js"
import style0 from "./adminSettings.vue?vue&type=style&index=0&id=11c5e75c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports